import { memo } from "react";
import {
  Box,
  Button,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { Check, Close } from "@mui/icons-material";

const SuccessDialog = memo(
  ({ open, onClose, prn, driverName, success = true, message }) => {
    const title = success ? "Form Updated Successfully" : "Update Failed";

    const defaultMessage = success
      ? "Your pre-onboarding form has been updated successfully."
      : "We were unable to update the pre-onboarding form. Please try again.";

    return (
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              color: success ? "#059669" : "#dc2626",
            }}
          >
            {success ? (
              <Check
                sx={{
                  fontSize: "28px",
                }}
              />
            ) : (
              <Close
                sx={{
                  fontSize: "28px",
                }}
              />
            )}

            {title}
          </Box>
        </DialogTitle>

        <DialogContent>
          <Box
            sx={{
              pt: 2,
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            {prn && (
              <Box
                sx={{
                  p: 2,
                  backgroundColor: success ? "#f0fdf4" : "#fef2f2",
                  borderRadius: 1,
                  border: success ? "1px solid #86efac" : "1px solid #fecaca",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    color: success ? "#059669" : "#dc2626",
                    fontWeight: 600,
                    mb: driverName ? 1 : 0,
                  }}
                >
                  PRN: {prn}
                </Typography>

                {driverName && (
                  <Typography
                    variant="body2"
                    sx={{
                      color: success ? "#059669" : "#dc2626",
                    }}
                  >
                    Driver Name: {driverName}
                  </Typography>
                )}
              </Box>
            )}

            <Typography
              variant="body2"
              sx={{
                color: "#6b7280",
              }}
            >
              {message || defaultMessage}
            </Typography>
          </Box>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={onClose}
            variant="contained"
            color={success ? "success" : "error"}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  },
);

SuccessDialog.displayName = "SuccessDialog";

export default SuccessDialog;
